import React from 'react';

// Slim banner shown above the player's bottom bar whenever they're a party
// to one or more pending trades. The user clicks it to open the TradePanel
// in review mode for the most recent pending trade.
export default function PendingTradeBanner({ trades, myPlayerId, onOpen }) {
  const pending = Object.values(trades || {})
    .filter((t) => t.status === 'pending' && (t.fromPlayerId === myPlayerId || t.toPlayerId === myPlayerId))
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
  if (pending.length === 0) return null;

  const top = pending[0];
  const isMine = top.fromPlayerId === myPlayerId;
  const counterName = isMine ? top.toName : top.fromName;
  const labelText = isMine
    ? `📨 You proposed a trade to ${counterName} — Open`
    : `📨 ${counterName} wants to trade — Open`;

  return (
    <button style={styles.banner} onClick={() => onOpen(top.id)}>
      <span style={styles.text}>{labelText}</span>
      {pending.length > 1 && <span style={styles.count}>+{pending.length - 1}</span>}
    </button>
  );
}

const styles = {
  banner: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '8px 12px', background: 'linear-gradient(180deg, rgba(212,168,71,0.22), rgba(166,131,48,0.22))', border: '1px solid #d4a847', color: '#f0e6d0', fontFamily: "'Press Start 2P', monospace", fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: '0.04em', boxShadow: '0 2px 12px rgba(212,168,71,0.3)' },
  text:   { textAlign: 'center' },
  count:  { background: '#facc15', color: '#1a0e00', fontWeight: 800, fontSize: 11, borderRadius: 8, padding: '0 6px' },
};
